/**
 * Created by Jerker Nord on 2020-02-26.
 */
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";

export class BonusBunniesDotNavigation extends PIXI.Container {

    private _ring:PIXI.Sprite;
    private _dot:PIXI.Sprite;
    private _index:number;

    constructor() {
        super();
        this._ring = new PIXI.Sprite(GameResources.getTextures("introDotActive")[0]);
        this.addChild(this._ring);
        this._dot = new PIXI.Sprite(GameResources.getTextures("introDotInactive")[0]);
        this._dot.position.set(5, 5);
        this._dot.visible = false;
        this.addChild(this._dot);
    }

    public activate():void {
        this._dot.visible = true;
    }

    public disable():void {
        this._dot.visible = false;
    }

    get index():number {
        return this._index;
    }

    set index(value:number) {
        this._index = value;
    }
}